module.exports = __webpack_public_path__ + "img/REFRESH_STATUS.63f6e927.svg";